const routes = [
  {
    // 2025女神节活动 
    path: '/goddessFestival',
    name: 'goddessFestival',
    component: () => import('@/views/activityCenter/goddessFestival/index.vue'),
    meta: {
      requiresAuth: false,
      title: '女神节快乐'
    }
  },
]

export default routes
